import { combineReducers } from "@reduxjs/toolkit";
import { filtersSlice, filtersSliceSelectors } from "./filters-slice";
import { notesState } from "./notes-slice";
import { notesSelectors } from "./notes-selectors";

export const contactCommitmentsReducer = combineReducers({
  filters: filtersSlice.reducer,
  notes: notesState.reducer,
});

export const commitmentsPageActions = {
  ...filtersSlice.actions,
  ...notesState.actions,
};

export const commitmentsPageSelectors = {
  ...filtersSliceSelectors,
  ...notesSelectors,
};
